<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
    >
      <template v-slot:item.network_name="{ item }">
        {{ item.network_name ? item.network_name : '-' }}
      </template>

      <template v-slot:item.action="{ item }">
        <b-dropdown
          class="actions-button nomaxh"
          variant="dark"
          :text="$t('global.actions')"
        >
          <b-dropdown-item
            v-if="!item.virtual_machine_name"
            @click.native="ipAttachToNetworkCard(item)"
            >{{ $t('servers.attachToANetworkCard') }}</b-dropdown-item
          >
          <b-dropdown-item
            v-if="item.virtual_machine_name"
            @click.native="ipDetachToNetworkCard(item)"
            >{{ $t('servers.detachFromANetworkCard') }}</b-dropdown-item
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click.native="ipReserve(item)">{{
            $t('servers.reservation')
          }}</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            class="dropdownAlertLabel"
            @click.native="openTerminatePopup(item)"
            >{{ $t('servers.terminate') }}</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </List>

    <!-- Create and Actions Popups -->
    <DetailModal
      :title="
        $t(dynamicOperationComponentTitle ? dynamicOperationComponentTitle : '')
      "
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <component
        v-if="showDetail"
        :is="dynamicOperationComponent"
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :selected="selected"
      />
    </DetailModal>

    <!-- Terminate Modal -->
    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'GatewayIpManagement',
  data() {
    return {
      search: '',
      filters: '',
      showDetail: false,
      loading: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        { text: 'global.ipAddress', value: 'ip_addr', size: '2fr' },
        { text: 'global.version', value: 'version' },
        { text: 'servers.networkName', value: 'network_name' },
        { text: 'global.actions', value: 'action' },
      ],
      data: [],
      pagination: {},
      meta: {},
      dynamicOperationComponentTitle: '',
      deleteOperationUrl: '',
      selected: '',
      networkId: '',
    }
  },
  props: {
    vmId: {
      type: String,
      default: '',
    },
  },
  computed: {
    getVmId() {
      return this.vmId ? this.vmId : this.$route.params.id
    },
  },
  created() {
    this.getNetworkCards()
    // this.getList()
  },
  methods: {
    getNetworkCards() {
      let $query = `iaas/virtual-network-cards?include=virtualMachine&virtualMachine=${this.getVmId}&position=id`

      ApiService.get($query)
        .then(({ data }) => {
          let d = data.data.filter((f) => f.device_number == 0)
          if (d && d[0]) {
            this.networkId = d[0].id
            this.getList()
          } else this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `packetbender/ip/overview?network=${
        this.networkId
      }&position=id|desc&page=${current_page ? current_page : 1}`

      if (this.search) $query += `&ip_addr=${this.search}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeDetail() {
      this.showDetail = false
    },
    ipAttachToNetworkCard(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.attachToANetworkCard'
      this.dynamicOperationComponent = 'IPAttachToNetworkCard'
      this.showDetail = true
    },
    ipDetachToNetworkCard(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.detachFromANetworkCard'
      this.dynamicOperationComponent = 'IPDetachToNetworkCard'
      this.showDetail = true
    },
    ipReserve(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.reservation'
      this.dynamicOperationComponent = 'IPReserve'
      this.showDetail = true
    },
    openTerminatePopup(item) {
      this.deleteOperationUrl = `packetbender/ip/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    IpCreate: () => import('@/components/forms/IpCreate'),
    IPReserve: () => import('@/components/forms/IPReserve'),
    IPAttachToNetworkCard: () =>
      import('@/components/forms/IPAttachToNetworkCard'),
    IPDetachToNetworkCard: () =>
      import('@/components/forms/IPDetachToNetworkCard'),
  },
}
</script>
